<template>
  <div id="contenedor-contrato-insumos-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        rounded
        @click="nuevoFrente">
        <v-icon left small>
          mdi-plus
        </v-icon>
        Nuevo
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ContratoFrentesToolBar',
  components: {
  },
  data() {
    return {};
  },
  methods: {
    nuevoFrente() {
      this.$emit('nuevoFrente');
    },
  },
};
</script>

<style lang="scss">

</style>
